import { Utils } from '@genial/utils';

import { ReturnTypeOf_InserirMovimentacaoClubes } from '../../../../../../../../store/product/external/types';
import { ClubsEntityNormalized } from '../../../../../../../../store/product/types';
import { TicketApplicationBaseInfoProps } from '../../components/TicketApplicationSuccessDetails';

export const getClubsSuccessInfos = (
  offer: ClubsEntityNormalized,
  investedValue: number,
  order: ReturnTypeOf_InserirMovimentacaoClubes
): TicketApplicationBaseInfoProps => {
  const orderDetails = [
    { label: 'Gestor', value: offer.managerNameNormalized },
    { label: 'Produto', value: offer.clubNameNormalized },
    { label: 'Valor a investir', value: Utils.Mask.Money(investedValue) },
  ];

  return {
    orderHash: order.idMovimentacaoClubes.toString(),
    orderDetails,
  };
};
